export function createCacheKey(config) {
    return JSON.stringify(config, [
        "url",
        "method",
        "baseURL",
        "headers",
        "params",
        "data",
        "auth",
        "proxy",
    ]);
}
export function wrapCache(provider) {
    return provider;
}
